// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ReportCustomOmzetRecap_formItem__3atSP"};